import { triggerClientSideDownload } from './triggerClientSideDownload';

export function downloadAvailableWarehousesAsCsv(warehouses = []) {
  const csvHeaders = ['Warehouse Name', 'Warehouse Id'];
  const csvRows = warehouses.map((warehouse) => [warehouse.name, warehouse.id]);
  const csvContent = [csvHeaders, ...csvRows].map((row) => row.join(',')).join('\n');

  triggerClientSideDownload({
    content: csvContent,
    contentType: 'text/csv;charset=utf-8;',
    fileName: 'warehouse_ids.csv',
  });
}
